import { Link } from "react-router-dom";

export const Logo = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M32 9 58 54H6Z" fill="none" stroke="#F59E0B" strokeWidth="5" strokeLinejoin="round" />
    <path d="m21 39 7.5 7.5L44 31" fill="none" stroke="#F5F1E8" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Wordmark = ({ to = "/" }) => (
  <Link to={to} data-testid="brand-logo-link" className="group flex items-center gap-3">
    <Logo className="w-8 h-8 transition-transform duration-500 group-hover:rotate-[120deg]" />
    <span className="leading-none">
      <span className="font-display-x block text-lg font-extrabold tracking-tight">VIGÍA</span>
      <span className="font-mono block text-[10px] uppercase tracking-[0.2em] text-[#F5F1E8]/60">by Ascentra</span>
    </span>
  </Link>
);
